import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Landing  from './pages/Landing'
import NotFound from './pages/NotFound'

// Chargés à la demande → hors du bundle public (le QR/accueil ne télécharge que Landing).
// L'admin (22 pages + libs) ne part qu'après connexion ; /signer et /cgv à la visite.
const AdminApp     = lazy(() => import('./AdminApp'))
const SignContract = lazy(() => import('./pages/SignContract'))
const CGVPage      = lazy(() => import('./pages/CGV'))

// Fallback minimal pendant le chargement d'un chunk (splash-like, cohérent avec index.html).
function ChunkLoader() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, background: '#0E4D6B', color: '#fff', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ fontWeight: 800, fontSize: 26, letterSpacing: '.5px' }}>Plouf <span style={{ color: '#F5C142' }}>&amp;</span> Go</div>
      <div style={{ width: 32, height: 32, border: '3px solid rgba(255,255,255,.25)', borderTopColor: '#5BC8E8', borderRadius: '50%', animation: 'bootspin .8s linear infinite' }} />
    </div>
  )
}

export default function App() {
  return (
    <Suspense fallback={<ChunkLoader />}>
      <Routes>
        <Route path="/"        element={<Landing />} />
        <Route path="/signer"  element={<SignContract />} />
        <Route path="/404"     element={<NotFound />} />
        <Route path="/cgv"     element={<CGVPage />} />
        <Route path="/*"       element={<AdminApp />} />
      </Routes>
    </Suspense>
  )
}
